import { FC, MouseEvent } from 'react'
import { ToggleButton, ToggleButtonGroupProps } from '@mui/material'
import { ToggleButtonContainer, ToggleButtonGroup } from './ssmDrawerViewToggle.styles'

interface Props extends ToggleButtonGroupProps {
  leftLabel: React.ReactNode
  centerLabel: React.ReactNode
  alignment?: string | null
  onAlignmentChange?: (alignment: string | null) => void
}

const SSMDrawerViewToggle: FC<Props> = ({
  leftLabel,
  centerLabel,
  alignment = 'left',
  onAlignmentChange,
  ...props
}) => {
  const handleAlignment = (event: MouseEvent<HTMLElement>, newAlignment: string | null) => {
    // Prevent deselection - only allow switching between views, not deselecting
    if (newAlignment === null) {
      return
    }
    if (onAlignmentChange) {
      onAlignmentChange(newAlignment)
    }
  }

  return (
    <ToggleButtonContainer className="toggle-view-button-container">
      <ToggleButtonGroup value={alignment} exclusive onChange={handleAlignment} aria-label="text alignment" {...props}>
        <ToggleButton value="left" aria-label="left aligned">
          {leftLabel}
        </ToggleButton>
        <ToggleButton value="center" aria-label="centered">
          {centerLabel}
        </ToggleButton>
      </ToggleButtonGroup>
    </ToggleButtonContainer>
  )
}

export default SSMDrawerViewToggle
